/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./health.vue?vue&type=template&id=00273f2c&scoped=true"
import script from "./health.vue?vue&type=script&lang=js"
export * from "./health.vue?vue&type=script&lang=js"
import style0 from "./health.vue?vue&type=style&index=0&id=00273f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00273f2c",
  null
  
)

export default component.exports